import type { ResourceConfig } from "../types";

export const staffConfig = {
  displayName: "员工",
  category: "staff",
  permissions: {
    "read:all": {
      label: "查看所有员工",
      description: "可以查看系统中所有员工信息",
    },
    "write:all": {
      label: "管理所有员工",
      description: "可以创建、编辑、删除员工",
    },
    "read:own": {
      label: "查看自己的员工统计",
      description: "可以查看自己的员工详情和统计数据",
    },
  },
  navigation: {
    path: "/staff",
    label: "员工管理",
    icon: "Users" as const,
    requiredPermissions: ["read:all"] as const,
    group: "management" as const,
    order: 20,
  },
} satisfies ResourceConfig;
